module.exports = __webpack_public_path__ + "static/esailingTV_2-61d4c8257b7e945f149baf2c33501f29.png";